/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';

import { SpaceOverviewLoader } from '@confluence/space-overview';

import { ContentExtensionsProvider } from '../../ContentExtensionsProvider';
import SpaceBase from '../../SpaceBase';
import { LazyDwellTime } from '../lazyComponents';
import { CommentContextWrapper } from '../commentContextWrapper';

// Currently SSR renders SpaceOverviewLoader directly
// TODO: We should render everything on the server side to unify the route files
export const SpaceOverviewRouteComponent = ({ spaceKey }) => (
	<Fragment>
		<SpaceBase>
			<CommentContextWrapper>
				<ContentExtensionsProvider>
					<SpaceOverviewLoader spaceKey={spaceKey} />
				</ContentExtensionsProvider>
			</CommentContextWrapper>
		</SpaceBase>
		<LazyDwellTime />
	</Fragment>
);
